import { showError } from 'nuxt/app'
import { defineStore } from 'pinia'

export const useSnackbarStore = defineStore({
  id: 'snackbarStore', 
  state: () => {
    /**
     * Snackbar data
     */
    return {
      message: '',
      color: '',
      show: false
    }
  },
  actions: {
    /**
     * Show a snackbar with a message
     * @param {String} message - message to display
     * @param {String} color - color of the snackbar
     */
    showSnackbar(message, color) {
      this.message = message
      this.color = color
      this.show = true
    },

    /**
     * Close the snackbar
     */
    closeSnackbar() {
      this.message = ''
      this.color = ''
      this.show = false
      console.log(this.message + ' ' + this.color + ' ' + this.show)
    },
  }
})
